// --- Hereditary Relationship ENUMS ---

export const FamilyRelationshipEnum = {
    MOTHER : "mother",
    FATHER : "father",
    MATERNAL_GRANDMOTHER : "maternal_grandmother",
    MATERNAL_GRANDFATHER : "maternal_grandfather",
    PATERNAL_GRANDMOTHER : "paternal_grandmother",
    PATERNAL_GRANDFATHER : "paternal_grandfather",

    MATERNAL_AUNT : "maternal_aunt",
    MATERNAL_UNCLE : "maternal_uncle",
    PATERNAL_AUNT : "paternal_aunt",
    PATERNAL_UNCLE : "paternal_uncle",

    BROTHER : "brother",
    SISTER : "sister",
    OTHER : "other",
} as const;

export type FamilyRelationshipEnum = typeof FamilyRelationshipEnum[keyof typeof FamilyRelationshipEnum];

